export enum CompetitorTier {
    TIER_1 = 1,
    TIER_2 = 2,
    TIER_3 = 3,
}
